"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAuctionSummaryDto = instanceOfAuctionSummaryDto;
exports.AuctionSummaryDtoFromJSON = AuctionSummaryDtoFromJSON;
exports.AuctionSummaryDtoFromJSONTyped = AuctionSummaryDtoFromJSONTyped;
exports.AuctionSummaryDtoToJSON = AuctionSummaryDtoToJSON;
exports.AuctionSummaryDtoToJSONTyped = AuctionSummaryDtoToJSONTyped;
var WinningOfferDto_1 = require("./WinningOfferDto");
/**
 * Check if a given object implements the AuctionSummaryDto interface.
 */
function instanceOfAuctionSummaryDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('winningBidderId' in value) || value['winningBidderId'] === undefined)
        return false;
    if (!('winningBidderName' in value) || value['winningBidderName'] === undefined)
        return false;
    if (!('winningBidAmount' in value) || value['winningBidAmount'] === undefined)
        return false;
    return true;
}
function AuctionSummaryDtoFromJSON(json) {
    return AuctionSummaryDtoFromJSONTyped(json, false);
}
function AuctionSummaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'winningBidderId': json['winningBidderId'],
        'winningBidderName': json['winningBidderName'],
        'winningBidAmount': json['winningBidAmount'],
        'winningOffer': json['winningOffer'] == null ? undefined : (0, WinningOfferDto_1.WinningOfferDtoFromJSON)(json['winningOffer']),
    };
}
function AuctionSummaryDtoToJSON(json) {
    return AuctionSummaryDtoToJSONTyped(json, false);
}
function AuctionSummaryDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'winningBidderId': value['winningBidderId'],
        'winningBidderName': value['winningBidderName'],
        'winningBidAmount': value['winningBidAmount'],
        'winningOffer': (0, WinningOfferDto_1.WinningOfferDtoToJSON)(value['winningOffer']),
    };
}
